import RepetitionInterval from '@/domain/termine/components/RepetitionInterval/RepetitionInterval';
import { DatePickerFormField } from '@/domain/termine/features/UpdateTermin/shared/FormFields/DatePickerFormField';
import { TerminWiederholung } from '@/domain/termine/shared/types';
import { useTranslation } from 'react-i18next';
import { RepetitionIntervalDrawer } from '@/domain/termine/features/UpdateTermin/Mobile/components/RepetitionIntervalDrawer';
import { Field, FieldLabel } from '@e2n/ui';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';

export function RepetitionIntervalFormField({ form }: UpdateTermineFormProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 w-full">
      <form.Field name="wiederholung">
        {(field) => (
          <Field className="flex flex-col w-full gap-1">
            <FieldLabel>{t('domain.termine.repeat')}</FieldLabel>
            <div className="block md:hidden">
              <RepetitionIntervalDrawer
                value={field.state.value}
                onChange={field.handleChange}
              />
            </div>
            <div className="hidden md:block">
              <RepetitionInterval
                value={field.state.value}
                onChange={field.handleChange}
              />
            </div>
          </Field>
        )}
      </form.Field>
      <form.Subscribe selector={(state) => state.values.wiederholung}>
        {(wiederholung) =>
          wiederholung !== TerminWiederholung.OHNE ? (
            <DatePickerFormField name="wiederholungBis" form={form} />
          ) : null
        }
      </form.Subscribe>
    </div>
  );
}
